import $axios from '@/store/axios-instance.js';

export const moduleName = 'client service list'

export const mutationType = {
    retrieveList : `[${moduleName}] retrieveList`,
}

export const actionType = {
    retrieveList : `[${moduleName}] retrieveList`,
}

export const getterType = {
    list: `[${moduleName}] list`,
    listTotal: `[${moduleName}] listTotal`,
}

export default {
    state: {
        clientServiceList: null,
    },
    mutations: {
        [mutationType.retrieveList](state, payload) {
            state.clientServiceList = payload
        }
    },
    actions: {
        [actionType.retrieveList](context, payload) {
            return new Promise((resolve, reject) => {
                if (!context.getters.currentClient) {
                    context.commit(mutationType.retrieveList, null)
                    resolve()
                } else {
                    $axios
                        .get(`clients/${context.getters.currentClient.id}/services`,{
                        params: payload
                    })
                        .then(response => {
                            context.commit(mutationType.retrieveList, response.data)

                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        }
    },
    getters: {
        [getterType.list](state) {
            return state.clientServiceList ? state.clientServiceList.services : []
        },
        [getterType.listTotal](state) {
            return state.clientServiceList ? state.clientServiceList.serviceCount : 0
        },
    }
}